var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("link", {
        attrs: {
          rel: "stylesheet",
          href:
            "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
        }
      }),
      _vm._v(" "),
      _vm.id_persona
        ? _c(
            "v-card",
            { staticClass: "p-0" },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "", "justify-center": "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          staticClass: "text-xs-center blue--text",
                          attrs: { xs12: "" }
                        },
                        [
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm
                                  .$moment(_vm.fecha_marcado)
                                  .format("DD/MM/YYYY")
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.l_historicos,
                              "no-data-text": _vm.loading
                                ? "Cargando..."
                                : "No se tiene registros",
                              loading: _vm.loading,
                              "item-key": "index",
                              "rows-per-page-text": "Filas por pagina",
                              pagination: _vm.pagination
                            },
                            on: {
                              "update:pagination": function($event) {
                                _vm.pagination = $event
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "headers",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "tr",
                                        _vm._l(props.headers, function(header) {
                                          return _c(
                                            "th",
                                            {
                                              key: header.text,
                                              staticClass: "text-xs-center",
                                              class: [
                                                "column sortable",
                                                _vm.pagination.descending
                                                  ? "desc"
                                                  : "asc",
                                                header.value ===
                                                _vm.pagination.sortBy
                                                  ? "active"
                                                  : ""
                                              ],
                                              attrs: { id: "cabecera_tabla" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.changeSort(
                                                    header.value
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "white"
                                                  }
                                                },
                                                [_vm._v("arrow_upward")]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(header.text) +
                                                  "\n                "
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        0
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "items",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-center" },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "text-xs-center",
                                              attrs: { xs12: "" }
                                            },
                                            [
                                              _c(
                                                "b",
                                                { staticClass: "blue--text" },
                                                [
                                                  _vm._v(
                                                    "Fecha ajuste:\n                    " +
                                                      _vm._s(
                                                        _vm
                                                          .$moment(
                                                            props.item
                                                              .fecha_ajuste
                                                          )
                                                          .format(
                                                            "DD/MM/YYYY  HH:mm:ss"
                                                          )
                                                      )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "table",
                                                {
                                                  staticClass:
                                                    "table-marcado-historico"
                                                },
                                                [
                                                  _c("tr", [
                                                    _c("th", [
                                                      _vm._v("Horario")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("th", [
                                                      _vm._v("Tolerancia")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("th", [
                                                      _vm._v("Marcado")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("th", [
                                                      _vm._v("Atraso")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("th", [
                                                      _vm._v("Descripción")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("th", [
                                                      _vm._v("Clasifiación")
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    props.item.marcados,
                                                    function(marcado) {
                                                      return _c(
                                                        "tr",
                                                        {
                                                          key:
                                                            marcado.id_control_asistencia,
                                                          style:
                                                            marcado.atraso > 0
                                                              ? "background:rgb(219, 62, 177,0.3"
                                                              : marcado.tipo_marcado ==
                                                                "I"
                                                              ? "background:rgb(252, 76, 2,0.3"
                                                              : ""
                                                        },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                width: "15%"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  marcado.horario
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                width: "15%"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  marcado.tolerancia
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                width: "15%"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    marcado.hora_marcada
                                                                      ? marcado.hora_marcada
                                                                      : "-"
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                width: "15%"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  marcado.atraso
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                width: "55%"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    marcado.descripcion_caso
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                width: "55%"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    marcado.detalle_marcado
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1414986057
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-408e5e8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-408e5e8e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/tipificacion/components/HistoricoAjustes.vue
// module id = null
// module chunks = 